module.exports = __webpack_public_path__ + "static/img/img_7.114172e6.jpg";